/* global axios */
import ApiClient from './ApiClient';

class NetworkDiagnosticAPI extends ApiClient {
  constructor() {
    super('network_diagnostic', { accountScoped: true });
  }

  run(sample) {
    return axios.get(this.url, {
      params: { sample },
      timeout: 10000,
      headers: { 'Cache-Control': 'no-cache' },
    });
  }
}

export default new NetworkDiagnosticAPI();
